/*
Model defined for Maintaining Lead Responses. It can also be used for transferring model
*/

export class LeadResponseModel {
    appointmentDate: string;
    appointmentTime: string;
    assignedBy: string;
    assignedByName: string;
    assignedTo: string;
    assignedToName: string;
    branch: Branch;
    wsfxBranchId: string;
    comment: string;
    consumerId: string;
    createdAt: string;
    email: string;
    ddInFavourOf: string;
    ddReferenceNumber: string;
    paymentSource: string;
    followUpStatus: string;
    forexPurposes: string[];
    id: string;
    mobile: string;
    name: string;
    firstName: string;
    lastName: string;
    sendNotification: string;
    partner: Partner;
    products: string[];
    registered: boolean;
    status: string;
    transactionMode: string;
    user: User;
    branchId: string;
    appId: string;
    paymentSouce: string;
    userId: string;
    partnerId: string;
    nameAsPerPan: any;
    dateOfBirth: any;
    gender: any;
    placeOfBirth: any;
    occupation: any;
    city: string;
    pinCode: any;
    country: string;
    address: any;
    kycMode: any;
    passportNumber: any;
    passportIsuueDate: any;
    passportExpiryDate: any;
    passportFileNo: any;
    passportIssuePlace: any;
    pan: any;
    passportIssueDate: Date;
    coApplicant1FirstName: string;
    coApplicant1LastName: string;
    coApplicant1Mobile: string;
    coApplicant1Email: string;
    coApplicant2FirstName: string;
    coApplicant2LastName: string;
    coApplicant2Mobile: string;
    coApplicant2Email: string;
    remitter: string;
    universityName: string;
    loanId: string;
    loanApplicationId: any;
}

export class User {
    address: string;
    branchId: string;
    city: string;
    country: string;
    email: string;
    firstName: string;
    id: string;
    lastName: string;
    mobile: string;
    photo: string;
    pinCode: string;
    state: string;
    userRoles: UserRole[];
}

export class UserRole {
    roleId: string;
    userId: string;
}

export class Branch {
    address: string;
    branchAccounts: BranchAccount[];
    branchCategory: string;
    branchStatus: string;
    branchType: string;
    city: string;
    email: string;
    id: string;
    latitude: string;
    longitude: string;
    mobile: string;
    name: string;
    partnerId: string;
    pinCode: string;
    state: string;
    wsflReferenceBranchId: string;
}

export class BranchAccount {
    accountId: string;
    branchId: string;
    createdAt: string;
    updatedAt: string;
}

export class Partner {
    address: string;
    alias: string;
    country: string;
    email: string;
    gstNumber: string;
    id: string;
    city: string;
    mobile: string;
    name: string;
    state: string;
    ddInFavourOf: string;
    ddReferenceNumber: string;
    panNumber: string;
    partnerStatus: string;
    partnerType: string;
    photo: string;
    hasVariableMargin: boolean;
    pinCode: string;
    userFirstName: string;
    userLastName: string;
    wsflPrimaryBranchId: string;
    wsflRelationshipManagerId: string;
    thirdPartyPartnerId: number;
    sourcePartnerId: string;
    thirdPartyTourAgentId: number;
    thirdPartyCustomerId: number;
    billingCycle: number;
    billingCycleType: string;
    logoVisibility: string;
    productsInterestedIn: any = [];
    products: any = [];
    useLogoOnInvoice: boolean;
    considerGst: boolean;
    commissionInclusiveGst: boolean;
    invoiceRequired: boolean;
    tourOperatorReferrer: boolean;
    agentReferred: boolean;
    referringAgentsIds: any = [];
    referredByAgents: any = [];
    showFxCalculator: boolean;
    bulkOrderAllowed: boolean;
    actionSell: boolean;
    showRateRange: boolean;
    sendCreationEmail: boolean;
    endDate: Date;
    excludeWsfx: boolean;
    onlyTourReferrers: boolean;
    startDate: Date;
    wsflReferenceBranchId: string;
    wsflPrimaryBranchName: string;
}

export class LeadCommentModel {
    appointmentDate: string;
    appointmentTime: string;
    assignedBy: string;
    assignedTo: string;
    comment: string;
    consumerLeadId: string;
    createdAt: string;
    updatedAt: string;
    assignedByUserName: string;
    assignedToUserName: string;
    status: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/lead/LeadResponseModel.ts